import { render, staticRenderFns } from "./Side-Home-Default-Group.vue?vue&type=template&id=23651e52"
import script from "./Side-Home-Default-Group.vue?vue&type=script&lang=js"
export * from "./Side-Home-Default-Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports